import React, { useState } from 'react'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { Container } from './AnalyticsDetails.styled'
import { AnalyticsList } from './AnalyticsList'
import { AnalysisResults } from './AnalysisResults'
import * as sxStyles from './AnalyticsDetails.styled'
import { usePageHeader } from '../../../../utils/hooks'
import { AnalyticsListMode } from '../list/Analytics'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { TFlourTimeFilterValues } from '../../../../types/models/Flours'
import { useAnalyticsServices } from '../services/services'

interface IFloursDataProps {
  mode: AnalyticsListMode
}

export const AnalyticsDetails: React.FC<IFloursDataProps> = ({ mode }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const isBakerModule = mode === 'products'
  const isPostAging = mode === 'post-aging'

  const { getArrivalDatesByPeriod } = useAnalyticsServices(isBakerModule)

  const [timeFilter, setTimeFilter] =
    useState<TFlourTimeFilterValues>('Last Month')
  const { productId } = useParams<{ productId: string }>()

  const { data, isLoading } = useQuery(
    ['arrival-dates-by-period', productId, timeFilter],
    () =>
      getArrivalDatesByPeriod({
        flour_product_id: isBakerModule ? undefined : productId!,
        baker_product_id: isBakerModule ? productId : undefined,
        period: timeFilter,
        filters: {
          post_aging: isBakerModule ? undefined : isPostAging,
        },
      }),
    {
      enabled: !!productId,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        setSelectedDeliveryId(undefined)
      },
    }
  )

  const arrivalDates =
    data?.results
      ?.find(
        (item) =>
          Number(
            isBakerModule ? item.baker_product_id : item.flour_product_id
          ) === Number(productId)
      )
      ?.arrival_dates.map((date, index) => ({
        id: index,
        date,
      })) || []

  usePageHeader({
    showGoBack: true,
  })

  const [selectedDeliveryId, setSelectedDeliveryId] = useState<
    string | undefined
  >()

  return (
    <Container>
      <Stack
        sx={sxStyles.flourDataMainWrapper}
        flexDirection={isSmallScreen ? 'column' : 'row'}
      >
        <Stack sx={sxStyles.flourListWrapper} flex={1}>
          <AnalyticsList
            mode={mode}
            deliveriesDates={arrivalDates}
            isLoading={isLoading}
            timeFilter={timeFilter}
            onTimeFilterChange={setTimeFilter}
            productId={productId}
            selectedDeliveryId={selectedDeliveryId}
            setSelectedDeliveryId={setSelectedDeliveryId}
          />
        </Stack>
        <Stack sx={sxStyles.flourDetailsWrapper} flex={2}>
          <AnalysisResults
            flourProductId={Number(productId)}
            selectedDeliveryId={selectedDeliveryId}
            isPostAging={isPostAging}
            isBakerModule={isBakerModule}
          />
        </Stack>
      </Stack>
    </Container>
  )
}
